import React from 'react';
import { Tooltip } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

/**
 * Green tick shown next to an upload field's label once a file is stored on the
 * record. Renders nothing when `uploaded` is falsy, so call sites can drop it in
 * unconditionally instead of repeating the `{x && (...)}` guard.
 *
 * Sizing lives in common.less (.bp-uploaded-check). It used to be inlined as
 * `fontSize: '170%'`, which made the tick taller than the label's line box — and
 * because a vertical form label is content-sized, the field underneath it sat
 * ~6px lower than the plain-labelled field beside it in the same Row.
 *
 * @param uploaded Truthy when the record already has a file (usually the file id).
 * @param title    Tooltip text. Defaults to "Uploaded".
 */
const UploadedCheck = ({ uploaded, title = 'Uploaded' }) =>
  uploaded ? (
    <Tooltip placement="rightTop" title={title}>
      <CheckOutlined className="bp-uploaded-check" />
    </Tooltip>
  ) : null;

export default UploadedCheck;
